import React, { Fragment } from 'react';
import {  LoaderBox} from '../components/utilities';



export default class MonetaWebStart extends React.Component {
    constructor(props) {
        super(props);

        
        
    }

    //#region Events

    componentDidMount() {

       

    }
    
    render() {

        return (<LoaderBox/>)

        
    }
}

